import { FunctionComponent } from 'react';

const ErrorPage: FunctionComponent = () => {
  return <h1>404 Not Found</h1>;
};

export default ErrorPage;
